import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import * as React from 'react';
import classNames from 'classnames';
import { prependPrefix } from '../../../../utils/style.js';
import { RegionSelector } from '../../region-selector/index.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var LegacyPhoneInput = /*#__PURE__*/function (_React$Component) {
  _inherits(LegacyPhoneInput, _React$Component);

  var _super = _createSuper(LegacyPhoneInput);

  function LegacyPhoneInput() {
    _classCallCheck(this, LegacyPhoneInput);

    return _super.apply(this, arguments);
  }

  _createClass(LegacyPhoneInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          username = _this$props.username,
          onRegionSelect = _this$props.onRegionSelect,
          onUsernameChange = _this$props.onUsernameChange,
          errorMsg = _this$props.errorMsg;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(prependPrefix('legacy-phone-input'), {
          error: errorMsg
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: "mobile-region"
      }, /*#__PURE__*/React.createElement(RegionSelector, {
        onSelect: onRegionSelect
      }), /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
        value: username,
        onChange: onUsernameChange
      })), errorMsg && /*#__PURE__*/React.createElement("div", {
        className: "form-error-msg"
      }, errorMsg));
    }
  }]);

  return LegacyPhoneInput;
}(React.Component);

export { LegacyPhoneInput };
